import { ListItem, Stack, Typography } from '@mui/material';
import { Link, ReferenceField } from 'react-admin';

import { SupplierAvatar } from '../suppliers/SupplierAvatar';
import { BuyerName } from '../buyers/BuyerName';
import type { ActivityCompanyCreated } from '../types';
import { RelativeDate } from '../misc/RelativeDate';
import { useActivityLogContext } from './ActivityLogContext';

type ActivityLogCompanyCreatedProps = {
    activity: ActivityCompanyCreated;
};

export function ActivityLogCompanyCreated({
    activity,
}: ActivityLogCompanyCreatedProps) {
    const context = useActivityLogContext();
    const { company } = activity;
    return (
        <ListItem disableGutters>
            <Stack direction="row" spacing={1} alignItems="center" width="100%">
                <SupplierAvatar width={20} height={20} record={company} />
                <Typography
                    component="p"
                    variant="body2"
                    color="text.secondary"
                    flexGrow={1}
                >
                    {company.criado_por}{' '}
                    cadastrou fornecedor{' '}
                    <Link to={`/persons/${company.id}/show`}>
                        {company.nome_razao}
                    </Link>
                    {context === 'all' && (
                        <>
                            {' '}
                            <RelativeDate date={company.data_cadastro} />
                        </>
                    )}
                </Typography>
                {context === 'company' && (
                    <Typography
                        color="textSecondary"
                        variant="body2"
                        component="span"
                    >
                        <RelativeDate date={company.data_cadastro} />
                    </Typography>
                )}
            </Stack>
        </ListItem>
    );
}
